import CalloutService from '../services/CalloutService'

const useCallout = (page: string, position: string) => {
  const getCallout = async () => {
    return await CalloutService.getCallout(page, position)
  }

  return [getCallout] as const
}
export default useCallout
